import { useTranslation } from 'react-i18next';
import { DataTable } from '../../../web/src/components/data-table.jsx';
import { translateColumns } from '../../../web/src/locale/translate-columns.js';
import { SCHEDULE_COLUMNS } from './../../../shared-site-web/screens/schedule-table.js';
import { useSiteLang } from '../layout/use-site-lang.js';
import { getMockSchedules } from './mock-data/mock-schedules.js';
import { inertActions, pairRow } from './mock-table.jsx';

/**
 * The schedules list, including a monthly transfer schedule pair, rendered
 * with the app's real DataTable + DoubleRow.
 * @returns {JSX.Element}
 */
export function SchedulesCard() {
	const { t } = useTranslation();
	const lang = useSiteLang();
	return (
		<DataTable
			columns={translateColumns(SCHEDULE_COLUMNS, t)}
			rows={getMockSchedules(lang)}
			title={t('page.title.schedules')}
			emptyMessage={t('empty.noSchedules')}
			renderRow={pairRow}
			renderActions={inertActions(t)}
		/>
	);
}
